export type WorkReportStatus = 'DRAFT' | 'APPROVED' | 'CANCELLED' | string;

export interface WorkReportAttachment {
  attachmentId: number;
  fileName: string;
  fileExt?: string | null;
  fileSize?: number | null;
}

export interface WorkReport {
  workReportId: number;
  title: string;
  reportDate: string;
  content: string;
  status: WorkReportStatus;
  authorUserId?: number | null;
  authorName?: string | null;
  approverUserId?: number | null;
  approverName?: string | null;
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
  canEdit?: boolean | null;
  canDelete?: boolean | null;
  canRequestApproval?: boolean | null;
  canApproveDirect?: boolean | null;
  canRevoke?: boolean | null;
  attachmentCount?: number | null;
  attachments?: WorkReportAttachment[];
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface WorkReportPayload {
  title: string;
  reportDate: string;
  content: string;
}

export function workReportStatusLabel(
  status?: string | null,
  approvalInProgress?: boolean | null
) {
  if (approvalInProgress) {
    return '결재 요청 중';
  }
  switch (status) {
    case 'DRAFT':
      return '작성중';
    case 'APPROVED':
      return '승인';
    case 'CANCELLED':
      return '취소';
    default:
      return status || '-';
  }
}

export function workReportStatusClass(
  status?: string | null,
  approvalInProgress?: boolean | null
) {
  if (approvalInProgress) {
    return 'pending';
  }
  return (status || '').toLowerCase();
}
